import React from 'react'
import { camelCase } from 'lodash'
import cx from 'classnames'
import styles from './ZoneIcon.scss'

interface ZoneIconProps {
  name: string
  className?: string
}

const ZoneIcon: React.FC<ZoneIconProps> = ({ name = '', className }) => {
  const isUsState = name.toLowerCase().startsWith('us/')
  const isjpState = name.toLowerCase().startsWith('jp/')

  const refinedZoneName = isUsState || isjpState ? name.slice(3) : name

  const zoneIconName = camelCase(refinedZoneName)

  if (!zoneIconName) return null

  const assetsPath = isUsState ? 'usaStatesFlags' : 'countryFlags'

  try {
    const url = require(`./${assetsPath}/${zoneIconName}.svg`)
    return <img src={url} className={cx(styles.icon, className)} alt={name} />
  } catch (e: any) {
    if (e.code !== 'MODULE_NOT_FOUND') {
      throw e
    }
    return null
  }
}

export default ZoneIcon

